module.exports = __webpack_public_path__ + "static/img/iphone7.3c15b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone7.png
// module id = Rgjq
// module chunks = 0